// extracted by mini-css-extract-plugin
export var ctaSections = "styles-module--cta-sections--851ad";
export var resourceMediaCard = "styles-module--resource-media-card--30d74";